import "jquery";
import "jquery-ui";
import { timesIcon } from "../../elements/icons/index.js";
import { widget } from "@foretagsplatsen/widgetjs";
import button from "@foretagsplatsen/finsit-design-system/widget-js/elements/button";

/**
 * `sortableListWidget` render a list and handle the re ordering of its elements
 * by drag 'n' drop inside the list.
 *
 * @param {{}} spec - Parameter object
 * @param {object[]} spec.items                    - list of items to render
 * @param {string} spec.cssClass - optional     css class to add to the list when rendered
 * @param {string} spec.cssId - optional        css id to add to the list when rendered
 * @param {function} spec.itemRenderer        - optional function used to compute a renderable object out of an item.
 *                                            Default implementation returns the item.
 * @param {string} spec.itemCssClass          - css class of each list item
 */
function sortableListWidget(spec, my) {
	spec ||= {};
	my ||= {};
	const that = widget(spec, my);

	my.items = spec.items || [];

	const cssClass = spec.cssClass | "";
	const cssId = spec.cssId | "";
	const itemRenderer =
		spec.itemRenderer ||
		function (item) {
			return item;
		};
	const itemCssClass = spec.itemCssClass || "";
	const itemRemoved = spec.itemRemoved || function () {};
	const itemSorted = spec.itemSorted || function () {};

	that.setItems = function (items) {
		my.items = items;
		that.update();
	};

	that.getItems = function () {
		return my.items;
	};

	that.renderContentOn = function (html) {
		const completeCssClass = `sortable-list ui-sortable connected-sortable ${cssClass}`;

		const list = html.ul(
			{
				klass: completeCssClass,
				id: cssId,
			},
			that.getItems().map((item, index) =>
				html.li(
					{
						class: [
							"connected-sortable",
							"compare-item",
							itemCssClass,
						],
					},
					html.span(
						{ class: "value pull-left" },
						itemRenderer(item, index),
					),
					button(
						{
							as: "span",
							onClick: () => {
								// eslint-disable-next-line no-shadow -- bad practice, we should fix this
								const index = my.items.indexOf(item);
								my.items.splice(index, 1);
								itemRemoved(item, index);
								that.update();
							},
						},
						timesIcon({
							class: "remove-list-item fa-large",
							dataTest: "remove",
						}),
					),
				),
			),
		);

		setupList(list);
	};

	function setupList(list) {
		list.asJQuery()
			.sortable({
				connectWith: ".connected-sortable",
			})
			.disableSelection();

		let originalIndex = -1;

		list.asJQuery().on("sortstart", (event, ui) => {
			originalIndex = ui.item.index();
		});

		list.asJQuery().on("sortstop", (event, ui) => {
			const index = ui.item.index();
			const item = my.items[originalIndex];
			my.items.splice(originalIndex, 1);
			my.items.splice(index, 0, item);
			originalIndex = -1;
			itemSorted(item, index);
		});
	}

	return that;
}

export default sortableListWidget;
